import { render, staticRenderFns } from "./FullScreenKongSkeleton.vue?vue&type=template&id=1af2ab78&scoped=true&"
import script from "./FullScreenKongSkeleton.vue?vue&type=script&lang=js&"
export * from "./FullScreenKongSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenKongSkeleton.vue?vue&type=style&index=0&id=1af2ab78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af2ab78",
  null
  
)

export default component.exports